import Head from 'next/head';

export default function PrivacyPolicy() {
  return (
    <>
      <Head>
        <title>Privacy Policy | York Round Table | #DoMore</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <div className="mx-auto w-full max-w-screen-xl">
        <article className="mx-auto w-full max-w-screen-lg">
          <h1 className="text-4xl text-rt-orange text-center mb-10">
            York Round Table Privacy Policy
          </h1>
          <div className="mx-auto w-full max-w-screen-md text-white">
            <h2 className="mb-4 text-2xl">Our contact details</h2>
            <p className="mb-4">Name: York Round Table</p>
            <p className="mb-4">E-mail: yorkroundtable65@gmail.com</p>
            <h2 className="mb-4 mt-8 text-2xl">The type of personal information we collect</h2>
            <p className="mb-4">We currently collect and process the following information:</p>
            <ul className="mb-4 ml-8">
              <li className="list-outside list-disc">
                Personal identifiers, contacts and characteristics (for example, name and contact
                details)
              </li>
              <li className="list-outside list-disc">
                For some of our events we may also ask you for payment details. These are processed
                via a third-party payment processor, Square, and we never have access to this
                information.
              </li>
            </ul>
            <h2 className="mb-4 mt-8 text-2xl">
              How we get the personal information and why we have it
            </h2>
            <p className="mb-4">
              Most of the personal information we process is provided to us directly by you for one
              of the following reasons:
            </p>
            <ul className="mb-4 ml-8">
              <li className="list-outside list-disc">Contacting us via our online contact form</li>
              <li className="list-outside list-disc">Registering for one of our events</li>
            </ul>
            <p className="mb-4">
              We use the information you have provided us to provide you with information, products
              or services that you request from us or which we feel may interest you, where you have
              agreed to be contacted for such purposes.&nbsp;
            </p>
            <p className="mb-4">
              We may share this information with Round Table Great Britain &amp; Ireland.
            </p>
            <p className="mb-4">
              Under the UK General Data Protection Regulation (UK GDPR), the lawful bases we rely on
              for processing this information are:
            </p>
            <ul className="mb-4 ml-8">
              <li className="list-outside list-disc">
                <strong>Your consent:</strong>You are able to remove your consent at any time. You
                can do this by contacting yorkroundtable65@gmail.com.
              </li>
            </ul>
            <h2 className="mb-4 mt-8 text-2xl">How we store your personal information</h2>
            <p className="mb-4">Your information is securely stored.&nbsp;</p>
            <p className="mb-4">
              We keep the personal information you provide us&nbsp;for a period of 12
              months.&nbsp;We will then dispose of your information by securely destroying it.
            </p>
            <h2 className="mb-4 mt-8 text-2xl">Your data protection rights</h2>
            <p className="mb-4">Under data protection law, you have rights including:</p>
            <ul className="mb-4 ml-8">
              <li className="mb-4 list-outside list-disc">
                <strong>Your right of access</strong>&nbsp;- You have the right to ask us for copies
                of your personal information.&nbsp;
              </li>
              <li className="mb-4 list-outside list-disc">
                <strong>Your right to rectification</strong>&nbsp;- You have the right to ask us to
                rectify personal information you think is inaccurate. You also have the right to ask
                us to complete information you think is incomplete.&nbsp;
              </li>
              <li className="mb-4 list-outside list-disc">
                <strong>Your right to erasure</strong>&nbsp;- You have the right to ask us to erase
                your personal information in certain circumstances.&nbsp;
              </li>
              <li className="mb-4 list-outside list-disc">
                <strong>Your right to restriction of processing</strong>&nbsp;- You have the right
                to ask us to restrict the processing of your personal information in certain
                circumstances.&nbsp;
              </li>
              <li className="mb-4 list-outside list-disc">
                <strong>Your right to object to processing</strong>&nbsp;- You have the the right to
                object to the processing of your personal information in certain circumstances.
              </li>
              <li className="mb-4 list-outside list-disc">
                <strong>Your right to data portability</strong>&nbsp;- You have the right to ask
                that we transfer the personal information you gave us to another organisation, or to
                you, in certain circumstances.
              </li>
            </ul>
            <p className="mb-4">
              You are not required to pay any charge for exercising your rights. If you make a
              request, we have one month to respond to you.
            </p>
            <p className="mb-4">
              Please contact us at&nbsp;yorkroundtable65@gmail.com&nbsp;if you wish to make a
              request.
            </p>
            <h2 className="mb-4 mt-8 text-2xl">How to complain</h2>
            <p className="mb-4">
              If you have any concerns about our use of your personal information, you can make a
              complaint to us at yorkroundtable65@gmail.com.
            </p>
            <p className="mb-4">
              You can also complain to the ICO if you are unhappy with how we have used your data.
            </p>
            <p className="mb-4">
              The ICO&rsquo;s address:
              <br />
              Information Commissioner&rsquo;s Office
              <br />
              Wycliffe House
              <br />
              Water Lane
              <br />
              Wilmslow
              <br />
              Cheshire
              <br />
              SK9 5AF
            </p>
            <p className="mb-4">Helpline number: 0303 123 1113</p>
            <p className="mb-4">
              ICO website:&nbsp;<a href="https://www.ico.org.uk/">https://www.ico.org.uk</a>
            </p>

            <h2 className="mb-4 mt-8 text-2xl">Cookies</h2>
            <p className="mb-4">
              We use cookies in the operation of our shopping cart system so we can process your
              order. Like many websites, we use Google Analytics to improve how our website
              functions for our visitors. This also involves the use of cookies but does not use any
              personally identifiable information.
            </p>

            <p className="mb-4">
              Please see below for a list of cookies used on our website. Whilst we&apos;ll
              endeavour to keep this list updated, we use a few third party services and the list
              may become outdated if they change their cookies without notifying us.
            </p>

            <p className="mb-4">There are two types of cookies used on our website:</p>

            <p className="mb-4">
              First party cookies: these are our own cookies, controlled by us and used to run the
              shopping cart system & provide information about usage of our site.
            </p>
            <p className="mb-4">
              Third party cookies: these are cookies found in other companies’ internet tools which
              we are using to enhance our site, for example Google, Facebook and Twitter have their
              own cookies, which are controlled by them.
            </p>

            <h3 className="mb-4 mt-8 text-2xl">What rights you have over your data</h3>

            <p className="mb-4">
              If you have an account on this site, you can request to receive an exported file of
              the personal data we hold about you, including any data you have provided to us. You
              can also request that we erase any personal data we hold about you. This does not
              include any data we are obliged to keep for administrative, legal, or security
              purposes.
            </p>
          </div>
        </article>
      </div>
    </>
  );
}
